import createAction from '../services/create-action';

export const SET_IS_LOADING = 'isLoading/SET';

export const setIsLoading = createAction(SET_IS_LOADING, (entity, id, isLoading) => ({
  entity,
  id,
  isLoading,
}));



// WEBPACK FOOTER //
// ./app/actions/set-is-loading.js